import React, { Component } from "react";
export default function VerticalDots(props) {
return (

<svg xmlns="http://www.w3.org/2000/svg" style={props.style} height={props.height} width={props.width} viewBox="0 0 24 24">
	<path fill={props.fill} stroke={props.stroke} d="M12 18c1.657 0 3 1.343 3 3s-1.343 3-3 3-3-1.343-3-3 1.343-3 3-3zm0-9c1.657 0 3 1.343 3 3s-1.343 3-3 3-3-1.343-3-3 1.343-3 3-3zm0-9c1.657 0 3 1.343 3 3s-1.343 3-3 3-3-1.343-3-3 1.343-3 3-3z"/>
</svg>	

)}


// WEBPACK FOOTER //
// ./src/assets/img/vertical_dots.jsx